// extracted by mini-css-extract-plugin
export var footer = "br10-l";
export var footerBottom = "br10-y";
export var footerNavItem = "br10-x";
export var footerNavs = "br10-w";
export var footerTop = "br10-m";
export var footerTopQrcode = "br10-n";
export var footerTopQrcodeBox = "br10-o";
export var footerTopQrcodeBoxImg = "br10-p";
export var footerTopQrcodeText = "br10-q";
export var footerTopQrcodeTextHighlight = "br10-r";
export var footerTopRight = "br10-s";
export var footerTopRightAddress = "br10-v";
export var footerTopRightDescription = "br10-u";
export var footerTopRightLogo = "br10-t";